import { render, staticRenderFns } from "./ViewChangeRequestPolicyDetailsLegacy.vue?vue&type=template&id=45aba740"
import script from "./ViewChangeRequestPolicyDetailsLegacy.vue?vue&type=script&lang=ts"
export * from "./ViewChangeRequestPolicyDetailsLegacy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports